import React, { Fragment } from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import Header from "../Header";

const RootLayout = () => {
  return (
    <Fragment >
      <Flex minH={'100vh'} flexDirection={'column'}>
      <Header />
        <Flex flexDirection={"row"} w={"100%"} bgColor={"#F5F5F5"} minHeight={{base: '89vh', md: '89vh', lg: '89vh', xl: '89vh', '2xl': '93vh'}}>
          <Sidebar isBase={false} data={
            [
            // ORDER MANAGEMENT
            {'Orders': [{title: 'All Order', url: '/orders/all'},{title: 'Archived Order', url: '/orders/archived'},
              // {title: 'Search Order Item', url: '/orders/search-orderItem-tags'},
              {title: 'Draft Order', url: '/orders/draft'},{title: 'Published Order', url: '/orders/published'},
                             {title: 'Order Created', url: '/orders/created'}, {title: 'Awaiting Verification', url: '/orders/awaiting-verification'}, {title: 'Verified Orders', url: '/orders/verified'},
                            //  {title: 'Out for Delivery', url: '/orders/out-for-delivery'}, 
                             {title: 'Delivered Orders', url: '/orders/delivered'},  
                            //  {title: 'Fulfilled Orders', url: '/orders/fulfilled'}, 
                            //  {title: 'Return Order', url: '/orders/return-order'},
                              {title: 'Canceled Orders', url: '/orders/canceled'},
                              {title: 'Payment Pending', url: '/orders/payment-pending'},
                              {title: 'Terminated', url: '/orders/terminated'}, 
                              {title: 'Extended', url: '/orders/extended'}, 
                              {title: 'Early Closure', url: '/orders/early-closure'}, 
                              {title: 'Active', url: '/orders/active'}, 
                              {title: 'Cancelled', url: '/orders/cancelled'}, 
                              {title: 'Ending Tommorrow', url: '/orders/ending-tomorrow'}, 
                              {title: 'Ended', url: '/orders/ended'}, 
                              {title: 'Completed', url: '/orders/completed'}, 
                              {title: 'Founders', url: '/orders/founders'}, 
                              {title: 'Individuals', url: '/orders/individuals'}, 
            ],
            'icon': `<BiCube fontSize={'26px'}/>`,
            'id': 'ORDER_MANAGEMENT'},

            // CUSTOMER VERIFICATION
            {'Customer Verification': [{title: 'All Verifications', url: '/verification/all'}, {title: 'Verification Pending', url: '/verification/pending'}, {title: 'Customer Verified', url: '/verification/customer-verified'}, {title: 'Unverified', url: '/verification/un-verified'}, {title: 'Credit Report', url: '/verification/credit-report'} ],
            'icon': `<BsFillPersonCheckFill fontSize={'26px'}/>`,
            'id': 'CUSTOMER_MANAGEMENT'},
            
            // TENURE MANAGEMENT
            {'Tenures': [
              {title: 'All Tenure', url: '/tenures/all'},
              {title: 'Tenure Issued', url: '/tenures/invoice/issued'},
              {title: 'Tenure Decline', url: '/tenures/invoice/decline'},
              {title: 'Tenure Defaulted', url: '/tenures/invoice/defaulted'},
              {title: 'Tenure Defaulted Cut Off', url: '/tenures/invoice/defaulted-cut-off'},
              {title: 'Tenure Defaulted Due', url: '/tenures/invoice/defaulted-due'},
              {title: 'Tenrue Failed', url: '/tenures/invoice/failed'},
              {title: 'Tenrue Paid', url: '/tenures/invoice/paid'},
              {title: 'Tenure Pending', url: '/tenures/invoice/pending'},
              ],
            'icon': `<RxLapTimer fontSize={'26px'}/>`, 
            'id': 'TENURE_MANAGEMENT'},
            
            // RETURN MANAGEMENT
            // {'Returns': [
            //   {title: 'All Return', url: '/returns/all'},
            //   {title:"Return Approved", url:"/returns/approved"},
            //   {title:"Return Generated", url:"/returns/generated"},
            //   {title:"Return Completed", url:"/returns/completed"},
            //   {title:"Return Order Picked", url:"/returns/order-picked"},
            //   {title:"Received at Warehouse", url:"/returns/received-at-warehouse"},
            //   {title:"QC Completed", url:"/returns/qc-completed"},
            //   {title:"Settlement Calculated", url:"/returns/settlement-calculated"},
            //   {title:"Return Request Closed", url:"/returns/closed-requests"},
            // ],
            // 'icon': `<TbTruckReturn fontSize={'26px'}/>`,
            // 'id': 'RETURNS_MANAGEMENT'},

            // DISPUTE MANAGEMENT
            // {'Disputes': [{title: 'All Dispute', url: '/dispute/all'}],
            // 'icon': `<IoMdChatbubbles fontSize={'26px'}/>`,
            // 'id': 'DISPUTE_MANAGEMENT'},

            // SETTLEMENT MANAGEMENT
            // {'Settlements': [{title: 'All Settlement', url: '/settlements/all'}],
            // 'icon': `<BsFileEarmarkCheckFill fontSize={'26px'}/>`,
            // 'id': 'SETTLEMENT_MANAGEMENT'},

            // DELIVERY BOY | ORDER DELIVERY
            // {'Order Delivery': [{title: 'All Deliveries', url: '/order-delivery/all'}, {title: 'Out of Delivery', url: '/order-delivery/out-for-delivery'}, {title: 'Delivered', url: '/order-delivery/delivered'}],
            // 'icon': `<TbTruckDelivery fontSize={'26px'}/>`,
            // 'id': 'DELIVERY_MANAGEMENT'},

            // DELIVERY BOY | ORDER RETURN
            // {'Return Pick up': [{title: 'All Returns', url: '/order-return/all'},{title: 'Approved Return', url: '/order-return/approved-return'}, {title: 'Picked up Orders', url: '/order-return/order-picked-up'}, {title: 'Delivered to Warehouse', url: '/order-return/delivere-to-warehouse'}],
            // 'icon': `<TbTruckReturn fontSize={'26px'}/>`,
            // 'id': 'DELIVERY_MANAGEMENT'},

            
            // USER MANAGEMENT
            {'User Access': [{url: '/user-access'}],
            'icon': `<BsFillPeopleFill fontSize={'26px'}/>`,
            'id': 'USER_MANAGEMENT'},

            // NOTIFICATIONS
            {'Notifications': [{url: '/notifications/all'}],
            'icon': `<IoIosNotifications fontSize={'26px'}/>`,
            'id': 'NOTIFICATION_MANAGEMENT'},

            // SETTINGs
            {'Settings': [{url: '/settings'}],
            'icon': `<IoMdSettings fontSize={'26px'}/>`,
            'id': 'SETTINGS_MANAGEMENT'},

            {'Inventory': [{url: '/inventory'}],
            'icon': `<IoMdSettings fontSize={'26px'}/>`,
            'id': 'INVENTORY_MANAGEMENT'},
            ]}
            />         
            <Outlet />
        </Flex>
      </Flex>
    </Fragment>
  );
};

export default RootLayout;
